import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import TopBanner from 'componentsV2/TopBanner';

const NetworkStatus = () => {
  const [offline, setOffline] = useState(false);

  const offlineStatus = () => {
    setOffline(!navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener('offline', offlineStatus);
    window.addEventListener('online', offlineStatus);

    return () => {
      window.removeEventListener('offline', offlineStatus);
      window.removeEventListener('online', offlineStatus);
    };
  }, []);

  return (
    <TopBanner visible={offline}>
      <p>
        <FormattedMessage id="errors.noInternetConnection" />
      </p>
    </TopBanner>
  );
};

export default NetworkStatus;
